import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function IdentificationSection() {
  const items = ['Conversaciones que alteran tu estado', 'Llegar a casa y seguir “enganchada”', 'Reaccionar más de lo que querés', 'Sentirte menos estable que antes'];
  return <SectionWrapper narrow data-id="element-83">
      <div className="flex flex-col space-y-10" data-id="element-84">
        <h2 className="text-3xl md:text-4xl text-text text-center" data-id="element-85">
          ¿Te identificás?
        </h2>

        <ul className="space-y-6" data-id="element-86">
          {items.map((item, index) => <li key={index} className="flex items-start" data-id="element-87">
              <span className="inline-block w-2 h-2 mt-2.5 mr-4 bg-plum rounded-full flex-shrink-0" data-id="element-88" />
              <span className="text-lg md:text-xl text-text-secondary leading-relaxed" data-id="element-89">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </SectionWrapper>;
}